import React from 'react'
import { Script } from 'gatsby'

const ThirdPartyScripts = () => {
  return (
    <>
      <Script type="text/javascript" id="hs-script-loader" async defer src="//js.hs-scripts.com/6428535.js"></Script>
    </>
  )
}

export default ThirdPartyScripts
